import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LiveIndicatorProps {
  /** Label text next to the pulse dot */
  label?: string;
  /** Dot color (default var(--olive)) */
  color?: string;
  className?: string;
}

export const LiveIndicator: React.FC<LiveIndicatorProps> = ({
  label = 'Data feed live',
  color,
  className
}) => (
  <Wrapper $color={color} className={className}>
    <Dot $color={color} />
    {label}
  </Wrapper>
);

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

const Wrapper = styled.span<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${({ $color }) => $color ?? 'var(--olive)'};
  font-weight: 500;
  font-size: inherit;
`;

const Dot = styled.span<{ $color?: string }>`
  width: 6px;
  height: 6px;
  background: ${({ $color }) => $color ?? 'var(--olive)'};
  border-radius: 50%;
  animation: ${pulse} 2s ease-in-out infinite;
`;
